import { createSelector } from 'reselect'

import { selectQbrState } from './selectQbrState'

export const selectRounding = createSelector(
  [selectQbrState],
  (state) => state.documentSettings.rounding
)
